import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-app bg-grey-50" }
const _hoisted_2 = { class: "s20" }
const _hoisted_3 = { class: "widget shadow-100 pb-2" }
const _hoisted_4 = { class: "container-full-2 my-5" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "font-semibold mt-4" }
const _hoisted_7 = { class: "text-sm text-grey-500" }
const _hoisted_8 = { class: "s13 flex justify-content-right" }
const _hoisted_9 = { class: "table separator skin2 selection" }
const _hoisted_10 = {
  class: "btn-circle",
  for: "check_all"
}
const _hoisted_11 = ["checked"]
const _hoisted_12 = { class: "flex-right" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "selection-item" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "value"]
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = {
  class: "square-xl rounded-15",
  style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "mb-1 font-semibold" }
const _hoisted_21 = { class: "text-sm text-grey-500" }
const _hoisted_22 = { class: "mb-2 color-info" }
const _hoisted_23 = { class: "text-sm text-grey-500" }
const _hoisted_24 = { class: "text-sm text-grey-500" }
const _hoisted_25 = { class: "text-sm text-grey-500" }
const _hoisted_26 = { class: "flex-right" }

import { onMounted, ref, inject, computed } from 'vue';
    import axios from 'axios';
    import AdminCredentialsInfosModal from './AdminCredentialsInfosModal.vue';
    import ConfirmationModal from '@/components/ConfirmationModal.vue';
    import { formatDate } from '../../utils';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminListView',
  setup(__props) {

    const BACKEND_URL = inject('BACKEND_URL');
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const credentialsInfosModalRef = ref<InstanceType<typeof AdminCredentialsInfosModal> | null>(null);
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);
    const selectedItems = ref([] as any[]);
    const areAllItemsSelected = computed(() => {
        return itemsList.value.length == selectedItems.value.length;
    });

    onMounted(() => {
        doListAdminsAction();
    });

    async function doListAdminsAction() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/admins/list`);
            itemsList.value = httpResponse.data;
        } catch(error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function openCredentialsModal(item: any) {
        credentialsInfosModalRef?.value?.open(item);
    }

    async function doDeleteAdminAction(item: any) {
        const confirmation = await confirmationModalRef.value?.open("Administrateurs", "Voulez-vous vraiment supprimer cet administrateur ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/admins/destroy/${item.id}`, {});
                const index = itemsList.value.findIndex(i => i.id == item.id);
                if (index > -1) {
                    const itemsListCloned = itemsList.value;
                    itemsListCloned.splice(index, 1);
                    itemsList.value = itemsListCloned;
                }
            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    async function doToggleEtatValideAction(itemsIds: any[]) {
        const confirmation = await confirmationModalRef.value?.open("Administrateurs", "Voulez-vous vraiment modifier l'état des éléments sélectionnés ?");
        if (confirmation) {
            try {
                loading.value = true;
                errorMessage.value = '';
                await axios.post(`/backoffice/admins/toggle_etat_valide`, { ids: itemsIds });

                itemsIds.forEach(itemId => {
                    const index = itemsList.value.findIndex(i => i.id == itemId);
                    if (index > -1) {
                        itemsList.value[index].etat_valide = itemsList.value[index].etat_valide == 1 ? 0 : 1;
                    }
                });

            } catch(error: any) {
                errorMessage.value = error.message;
            } finally {
                loading.value = false;
            }
        }
    }

    function handleCheckAll(_event: any) {
        const checked = _event.target.checked;
        if (checked) {
            selectedItems.value = itemsList.value.map(i => i.id);
        } else {
            selectedItems.value = [];
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, [
                _cache[1] || (_cache[1] = _createTextVNode("Administrateurs ", -1)),
                _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(itemsList.value.length) + ")", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                id: "btn-add",
                to: "/app/admins/form",
                class: "flex-center"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("button", { class: "btn normal ml-4 justify-content-center btn-filtre" }, [
                    _createElementVNode("img", {
                      src: "/icons/icon-add.svg",
                      class: "btn-icon",
                      alt: ""
                    }),
                    _createElementVNode("span", null, "Créer")
                  ], -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"form-field-floating default sm s4_mobile ml-3\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\">Trier</option><option value=\"\" selected>Ordre Décroissant</option><option value=\"\">Ordre Croissant</option><option value=\"\">De A - Z</option><option value=\"\">De Z - A</option></select></div><button class=\"btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter\"><img src=\"/icons/icon-filter.svg\" class=\"btn-icon\" alt=\"\"><span>Options</span></button>", 2))
            ]),
            _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"clear-both\"></div><div class=\"filter-set-area\"><div class=\"grid-filter6 mt-4 mb-0\"><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date1\" id=\"date1\" placeholder=\"\"><label for=\"date1\">Date de création &lt;=</label></div><div class=\"form-field-floating reactive sm\"><input type=\"date\" class=\"form-input\" name=\"date2\" id=\"date2\" placeholder=\"\"><label for=\"date2\">Date de création &gt;=</label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><div class=\"form-field-floating sm\"><select class=\"form-input-select\" name=\"pays\" id=\"pays\"><option value=\"\" selected>Tout les etats</option><option value=\"\">Actif</option><option value=\"\">Inactif</option></select><label for=\"pays\">Etat <b class=\"color-danger\">*</b></label></div><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-excel.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter Excel</span></button><button class=\"btn black normal justify-content-center mx-0 btn-filtre\"><img src=\"/icons/icon-pdf.svg\" class=\"btn-icon\" alt=\"\"><span>Exporter PDF</span></button></div></div>", 2))
          ]),
          _cache[25] || (_cache[25] = _createElementVNode("hr", { class: "s20 my-0 hr2 opacity-1" }, null, -1)),
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, [
                  _createElementVNode("label", _hoisted_10, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "check_all",
                      checked: areAllItemsSelected.value,
                      onChange: handleCheckAll
                    }, null, 40, _hoisted_11)
                  ])
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Nom d'utilisateur")
                ], -1)),
                _cache[8] || (_cache[8] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Role")
                ], -1)),
                _cache[9] || (_cache[9] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-up.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Date création")
                ], -1)),
                _cache[10] || (_cache[10] = _createElementVNode("th", null, [
                  _createElementVNode("img", {
                    src: "/icons/icon-filter-none.svg",
                    class: "size-xxs mt--1",
                    alt: ""
                  }),
                  _createTextVNode(" Dernière connexion")
                ], -1)),
                _withDirectives(_createElementVNode("th", _hoisted_12, [...(_cache[5] || (_cache[5] = [
                  _createStaticVNode("<button class=\"btn-ultra white2 tips display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-destroy.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Détruire</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn-ultra white2 tips\"><div class=\"btn-show\"><img src=\"/icons/icon-delete.svg\" class=\"btn-icon\" alt=\"\"><span>Supprimer</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn-ultra white2 tips\"><div class=\"btn-show\"><img src=\"/icons/icon-restaurer.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Restaurer</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button><button class=\"btn-ultra color2 tips\"><div class=\"btn-show\"><img src=\"/icons/icon-actif.svg\" class=\"btn-icon\" alt=\"\"><span>Actif</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 4)
                ]))], 512), [
                  [_vShow, false]
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (itemsList.value.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [...(_cache[11] || (_cache[11] = [
                    _createElementVNode("td", { colspan: "7" }, [
                      _createElementVNode("div", { class: "text-center text-grey-700" }, "Aucun élément trouvé")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "text-grey-700 over-effect",
                  key: 'admin_' + index
                }, [
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("label", {
                      class: "btn-circle",
                      for: 'item_check_' + index
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "selectedItems[]",
                        id: 'item_check_' + index,
                        value: item.id,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
                      }, null, 8, _hoisted_16), [
                        [_vModelCheckbox, selectedItems.value]
                      ])
                    ], 8, _hoisted_15)
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: !!item.photo_url ? item.photo_url : ('/assets/users/300w/' + item.avatar),
                        width: "100%"
                      }, null, 8, _hoisted_19)
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("div", {
                      class: "square-xl rounded-15 ml-3 px-3 py-3",
                      style: {"background-color":"rgb(var(--color-warning-rgb), 0.2)"}
                    }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-menu-securite.svg",
                        width: "100%"
                      })
                    ], -1))
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("h5", _hoisted_20, _toDisplayString(item.username), 1),
                    _cache[13] || (_cache[13] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_21, _toDisplayString((item.nom ?? '') + ' ' + (item.prenom ?? '')), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(item.role ? item.role.libelle : '-'), 1),
                    _cache[15] || (_cache[15] = _createTextVNode()),
                    _createElementVNode("span", _hoisted_23, [
                      _cache[14] || (_cache[14] = _createElementVNode("img", {
                        src: "/icons/icon-menu-securite.svg",
                        class: "size-xxs"
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(item.role ? item.role.codes_permissions.length : '-') + " Permissions", 1)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("b", _hoisted_24, _toDisplayString(_unref(formatDate)(item.created_at)), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("b", _hoisted_25, _toDisplayString(item.last_connection_at ? _unref(formatDate)(item.last_connection_at) : ''), 1)
                  ]),
                  _createElementVNode("td", _hoisted_26, [
                    _cache[22] || (_cache[22] = _createStaticVNode("<button class=\"btn-ultra white2 tips display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-destroy.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Détruire</span></div><div class=\"btn-loading display-none\"><div class=\"loader-dots\"></div></div></button>", 1)),
                    _createVNode(_component_custom_button, {
                      classesList: 'btn-ultra white2 tips',
                      id: 'btn-delete-' + item.id,
                      onClick: ($event: any) => (doDeleteAdminAction(item))
                    }, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-delete.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Supprimer", -1)
                      ]))]),
                      _: 1
                    }, 8, ["id", "onClick"]),
                    _cache[23] || (_cache[23] = _createStaticVNode("<button class=\"btn-ultra white2 tips display-none\"><div class=\"btn-show\"><img src=\"/icons/icon-restaurer.svg\" class=\"btn-icon icon-neutral\" alt=\"\"><span>Restaurer</span></div><div class=\"btn-loading\"><div class=\"loader-dots\"></div></div></button>", 1)),
                    _createVNode(_component_custom_button, {
                      classesList: 'btn-ultra white2 tips',
                      onClick: ($event: any) => (openCredentialsModal(item))
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-menu-securite.svg",
                          class: "btn-icon icon-neutral",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Informations de connexion", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    (item.etat_valide == 1)
                      ? (_openBlock(), _createBlock(_component_custom_button, {
                          key: 0,
                          classesList: 'btn-ultra color2 tips',
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, {
                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-actif.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Actif", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (item.etat_valide == 0)
                      ? (_openBlock(), _createBlock(_component_custom_button, {
                          key: 1,
                          classesList: 'btn-ultra color2 tips',
                          onClick: ($event: any) => (doToggleEtatValideAction([item.id]))
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-inactif.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Inactif", -1)
                          ]))]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_router_link, {
                      to: '/app/admins/form/' + item.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_custom_button, {
                          classesList: 'btn',
                          id: 'btn-edit-' + item.id
                        }, {
                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                            _createElementVNode("img", {
                              src: "/icons/icon-edit.svg",
                              class: "btn-icon",
                              alt: ""
                            }, null, -1),
                            _createElementVNode("span", null, "Editer", -1)
                          ]))]),
                          _: 1
                        }, 8, ["id"])
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    _createVNode(_component_custom_button, { classesList: 'btn white2 collapse-open-table' }, {
                      default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                        _createElementVNode("img", {
                          src: "/icons/icon-list.svg",
                          class: "btn-icon",
                          alt: ""
                        }, null, -1),
                        _createElementVNode("span", null, "Plus", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]))
              }), 128)),
              _cache[24] || (_cache[24] = _createElementVNode("tr", { class: "bg-white" }, [
                _createElementVNode("td", {
                  colspan: "7",
                  class: "collapse-content-table"
                }, [
                  _createElementVNode("div", { class: "grid6 grid-row-gap-1 px-10 pb-4" }, [
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ]),
                    _createElementVNode("p", { class: "flex text-grey-600" }, [
                      _createElementVNode("img", {
                        src: "/icons/icon-securite-permission.svg",
                        class: "size-xs icon-grey mr-2",
                        alt: ""
                      }),
                      _createTextVNode(" Permission 1")
                    ])
                  ])
                ])
              ], -1))
            ])
          ])
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1))
      ]),
      _createVNode(ConfirmationModal, {
        ref_key: "confirmationModalRef",
        ref: confirmationModalRef
      }, null, 512),
      _createVNode(AdminCredentialsInfosModal, {
        ref_key: "credentialsInfosModalRef",
        ref: credentialsInfosModalRef
      }, null, 512)
    ])
  ]))
}
}

})